var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealcloudMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "2 2 65 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#207cec;}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.54,
    y1: 22.31,
    x2: 67.14,
    y2: 22.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#207cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2095e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#21badb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#21d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#21e6d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22eccf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.57,31.24l2.35,2.35,6.83-6.83c1.19-1.19,1.85-2.77,1.85-4.46s-.66-3.27-1.85-4.46l-6.85-6.85-2.35,2.36,6.84,6.84c.56.56.87,1.31.87,2.1s-.31,1.54-.87,2.1l-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.31,3.33c.81,0,1.54.3,2.11.87l1.12,1.12-12.2,12.52c-1.2,1.2-1.85,2.78-1.85,4.47s.66,3.28,1.82,4.44l12.22,12.54-1.11,1.12c-.57.57-1.3.87-2.11.87s-1.54-.3-2.11-.87L4.2,24.42c-.57-.57-.87-1.3-.87-2.11s.3-1.54.87-2.11L20.2,4.2c.57-.57,1.3-.87,2.11-.87m0-3.33c-1.68,0-3.27.66-4.46,1.85L1.85,17.85c-1.19,1.19-1.85,2.77-1.85,4.46s.66,3.27,1.85,4.46l16,16c1.19,1.19,2.77,1.85,4.46,1.85s3.27-.66,4.46-1.85l3.41-3.46-14.5-14.88c-.57-.57-.88-1.32-.88-2.12s.31-1.56.88-2.12l14.52-14.9h0s-.02,0-.02,0l-3.43-3.43c-1.19-1.19-2.77-1.85-4.46-1.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.83,3.33c.2,0,.4.02.6.06.57.11,1.09.39,1.51.81l16,16c.56.56.87,1.28.87,2.08v.06c0,.8-.31,1.52-.87,2.08l-16,16c-.57.57-1.3.87-2.11.87s-1.54-.3-2.09-.86l-1.12-1.14.03-.04,12.16-12.48c1.2-1.2,1.85-2.78,1.85-4.47s-.66-3.28-1.82-4.44l-12.2-12.51-.04-.04,1.12-1.12c.57-.57,1.3-.87,2.11-.87m0-3.33c-1.68,0-3.27.66-4.46,1.85l-3.43,3.43h0,0s0,0,0,0h0s0,.01,0,.01l-12.55,12.55c-1.19,1.19-1.85,2.77-1.85,4.46s.66,3.27,1.85,4.46l14.46,14.46,1.53,1.55c1.19,1.19,2.77,1.85,4.46,1.85s3.27-.66,4.46-1.85l16-16c1.19-1.19,1.85-2.77,1.85-4.46,0,0,0,0,0,0,0,0,0,0,0,0,0-1.68-.66-3.27-1.85-4.46L49.3,1.85c-.89-.89-2.01-1.49-3.22-1.73-.41-.08-.82-.12-1.24-.12h0Zm-5.56,36.94l-.3-.3-12.23-12.23c-.56-.56-.87-1.31-.87-2.1s.31-1.54.87-2.1l12.52-12.52h0s12.2,12.5,12.2,12.5c.57.57.88,1.32.88,2.12s-.31,1.56-.88,2.12l-12.19,12.51h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealcloudMark);
export default __webpack_public_path__ + "static/media/dealcloud-mark.473296acf1053253aed70ca07f2c4f38.svg";
export { ForwardRef as ReactComponent };